"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sheet = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
require("@/components/overlay/backdrop/backdrop");
const sheet_controller_1 = require("@/controllers/sheet-controller");
const open_state_1 = require("@/utils/open-state");
// 드래그로 내린 거리가 패널 높이의 이 비율을 넘으면 닫힘으로 판정한다.
const DRAG_CLOSE_THRESHOLD_RATIO = 0.25;
let Sheet = class Sheet extends (0, open_state_1.withOpenState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.ariaModal = 'true';
        this.placement = 'bottom';
        this.width = 'small';
        this.fullWidth = false;
        this.dragging = false;
        this.dragStartY = 0;
        this.sheet = new sheet_controller_1.SheetController(this, {
            // 시트는 닫아도 잃는 것이 없는 내용을 담으므로 배경 클릭과 ESC로 모두 닫힌다.
            dismissOn: ['backdrop', 'escape'],
        });
        this.handleDragStart = (e) => {
            ;
            e.currentTarget.setPointerCapture(e.pointerId);
            this.dragging = true;
            this.dragStartY = e.clientY;
            this.sheetEl.style.transition = 'none';
        };
        this.handleDragMove = (e) => {
            if (!this.dragging)
                return;
            const deltaY = Math.max(0, e.clientY - this.dragStartY);
            this.sheetEl.style.transform = `translateY(${deltaY}px)`;
        };
        this.handleDragEnd = (e) => {
            if (!this.dragging)
                return;
            this.dragging = false;
            const deltaY = Math.max(0, e.clientY - this.dragStartY);
            this.sheetEl.style.transition = '';
            this.sheetEl.style.transform = '';
            if (deltaY > this.sheetEl.offsetHeight * DRAG_CLOSE_THRESHOLD_RATIO)
                this.close();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'dialog');
    }
    render() {
        return (0, lit_1.html) `
      <mm-backdrop></mm-backdrop>
      <aside class="panel" ?open=${this.open}>
        ${this.renderDragHandle()}
        <slot></slot>
      </aside>
    `;
    }
    renderDragHandle() {
        if (this.placement !== 'bottom')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div
        class="drag-handle"
        aria-hidden="true"
        @pointerdown=${this.handleDragStart}
        @pointermove=${this.handleDragMove}
        @pointerup=${this.handleDragEnd}
        @pointercancel=${this.handleDragEnd}
      ></div>
    `;
    }
    updated(changedProperties) {
        if (changedProperties.has('height'))
            this.syncHeight();
    }
    // 임의 값이라 나열할 수 없고 host가 소비하므로 host에 직접 주입한다.
    syncHeight() {
        if (!this.height) {
            this.style.removeProperty('--overlay-panel-height');
            return;
        }
        this.style.setProperty('--overlay-panel-height', this.height);
    }
};
Sheet.styles = [overlay_styles_1.overlaySurfaceStyles, overlay_styles_1.sheetPositionStyles, overlay_styles_1.sheetDragHandleStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-modal', reflect: true })
], Sheet.prototype, "ariaModal", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Sheet.prototype, "placement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Sheet.prototype, "width", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Sheet.prototype, "height", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true, attribute: 'full-width' })
], Sheet.prototype, "fullWidth", void 0);
__decorate([
    (0, decorators_js_1.query)('.panel')
], Sheet.prototype, "sheetEl", void 0);
Sheet = __decorate([
    (0, decorators_js_1.customElement)('mm-sheet')
], Sheet);
exports.Sheet = Sheet;
//# sourceMappingURL=data:application/json;base64,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